import styled from 'styled-components';


import { makeStandartMargins, useCustomTheme } from '../../styles';

type RootProps = {
	margin?: 'bottom-none' | 'bottom-small' | 'bottom-medium';
	isFetching?: boolean;
	fullWidth?: boolean;
}

const Root = styled.div<RootProps>`
	position: relative;
	display: inline-block;
	width: auto;
	height: auto;
	max-width: 100%;

	& .MuiInputAdornment-positionEnd {
		margin-left: 0;
	}

	& .MuiFormHelperText-contained {
		margin: 8px 0 0 0 ;
	}

	& .MuiInputBase-multiline {
		padding: 7px 0 0 0;
	}

	& .MuiInputBase-inputMultiline {
		padding-bottom: 6px;
	}

	${(p) => p.margin && `
		${makeStandartMargins(p.margin)};
	`}

	${(p) => p.isFetching && `
		& .MuiFilledInput-adornedEnd {
			padding-right: 20px;
		}
	`}

	${(p) => p.fullWidth && `
		width: 100%;
	`}
`;

const ErrorTextLayout = styled.span`
	display: inline-flex;
	align-items: center;
`;

const TextFieldPlaceholder = styled.span`
	${(p) => `
		color: ${useCustomTheme(p)[0].palette.blackDisabled};
	`} 
`;

export {
	Root,
	ErrorTextLayout,
	TextFieldPlaceholder,
};
